import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {AddressInputComponent} from '../../../../../shared/components/ux/inputs/address-input/address-input.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../../../../services/authentication.service';
import {UserService} from '../../../../../services/user-services/user.service';
import {first, map, take} from 'rxjs/operators';
import {BirthdateDividedComponent} from '../../../../../shared/components/ux/birthdate-divided/birthdate-divided.component';
import {CityInputComponent} from '../../../../../shared/components/ux/inputs/city-input/city-input.component';
import {slideBottomAnimation} from '../../../../../animation';
import {LocalSettingsService} from 'src/app/services/local-settings.service';
import {Location, NgClass, NgFor, NgIf} from '@angular/common';
import {AlertService} from 'src/app/services/alert.service';
import {forkJoin, from, Observable} from 'rxjs';
import {DocumentsService} from '../../../../../services/user-services/documents.service';
//import {MetaService} from 'src/app/services/meta.service';
import {Country, MatSelectCountryModule} from '@angular-material-extensions/select-country';
import {CountryService} from '../../../../../services/country.service';
import {SchoolService} from '../../../../../services/school.service';
import {CheckFormErrorDirective} from '../../../../../directives/checkFormError.directive';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {IconComponent} from '../../../../../shared/components/icons-svgs/icons-svgs.component';
import {UploadFileComponent} from '../../../../../shared/components/upload-file/upload-file.component';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormLoginComponent} from '../../../../../shared/components/forms/login-register/form-login.component';
import {HubspotService} from "../../../../../services/hubspot.service";
import {HelperService} from "../../../../../services/helper.service";
import {AccommodationCityInputComponent} from "../accommodation-city-input/accommodation-city-input.component";

@Component({
  selector: 'app-component-informations',
  templateUrl: './component-informations.component.html',
  styleUrls: ['./component-informations.component.scss'],
  animations: [slideBottomAnimation],
  standalone: true,
  imports: [
    NgIf,
    FormLoginComponent,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    MatFormFieldModule,
    MatInputModule,
    NgxIntlTelInputModule,
    MatSelectCountryModule,
    BirthdateDividedComponent,
    CityInputComponent,
    AddressInputComponent,
    UploadFileComponent,
    IconComponent,
    MatSelectModule,
    MatOptionModule,
    NgFor,
    CheckFormErrorDirective,
    TranslateModule,
    AccommodationCityInputComponent,
  ],
})
export class ComponentInformationsComponent implements OnInit, AfterViewInit {
  @Output() private newPage: EventEmitter<string> = new EventEmitter<string>();
  @Input() room;

  public user: any = null;
  public logged = false;
  public isMobile = false;
  public errors = {'firstname': null,'lastname': null,'birthplace': null};

  // user & doc form
  public userForm: UntypedFormGroup;
  public isFormSubmitted = false;
  private birthCountry: string = null;
  public schools: any[] = [];
  public selectedSchool: any;
  public startingCities: [{ id, name }];
  public userFormattedAddress: any = null;
  public isBirthdayCorrect = true;
  public predefinedCountries: Country[] = [];
  public open = false;
  public results = null;
  additionalAddressFormControl: UntypedFormControl;
  isFetching = false;
  fullHomeAddress;
  nationality;
  isManualInput = false;
  hasBeenClicked = true;

  public discoverOptions: any = [
    {
      name: 'CAT_1',
      values: ['1', '2']
    },
    {
      name: 'CAT_2',
      values: ['1', '2']
    },
    {
      name: 'CAT_3',
      values: ['1', '2', '3', '4']
    },
  ];

  @ViewChild('addressInput') private addressInput: AddressInputComponent;
  @ViewChild('birthdayInputs') private birthdayInputs: BirthdateDividedComponent;
  @ViewChild('cityInput') private cityInput: CityInputComponent;
  currentLanguage: string;

  constructor(
    public translate: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private _localSettings: LocalSettingsService,
    private location: Location,
    private alertService: AlertService,
    private userDocumentService: DocumentsService,
    private hubspotService: HubspotService,
    private countryService: CountryService,
    private helperService: HelperService,
    private schoolService: SchoolService,
  ) {
  }

  get fUser() {
    return this.userForm.controls;
  }

  ngOnInit(): void {

    this._localSettings.language$.subscribe(
      (language: string) => {
          this.currentLanguage = language;
      }
  );

    this.getCountries();
    this.schoolService.getAll().subscribe((data) => {
      this.schools = data.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {
          sensitivity: 'base',
          ignorePunctuation: true
        })
      );
    });
    this.isMobile = this.userService.isMobileUser;
    if (this.authenticationService.currentUserValue) {
      this.logged = true;
      this.user = this.userService.getInfos();
      this.getDocument('ID_PHOTO');
      this.getDocument('LETTRE_D_ADMISSION');

      this.nationality = this.user.nationality;
      this.additionalAddressFormControl = new UntypedFormControl(this.user.homeAdditionalAddress);
      const a = (this.user.homeAddress && this.user.homeAddress !== 'null' ? this.user.homeAddress + ', ' : '') + (this.user.postalCode ? this.user.postalCode + ', ' : '') +
        (this.user.homeCity_Info && this.user.homeCity_Info.name ? this.user.homeCity_Info.name + ', ' : '') +
        (this.user.homeCountry_Info && this.user.homeCountry_Info.name ? this.user.homeCountry_Info.name : '');
      this.userFormattedAddress = {
        route: this.user.homeAddress,
        postal_code: this.user.postalCode,
        city_id: this.user.homeCity_id,
        country: this.user.country,
      };
      let countryCode = this.countryService.getCountry(this.user.nationality);
      this.selectedSchool = this.user.school;

      // Get the user school given on register
      const uInfos = JSON.parse(this.user.informations);

      this.userForm = this.formBuilder.group({
        address: [a, Validators.required],
        birthdate: [this.user.birthdate, Validators.required],
        birthplace: [this.user.birthplace, [Validators.required]],
        nationality: [countryCode, Validators.required],
        lastname: [this.user.lastname, Validators.required],
        firstname: [this.user.firstname, Validators.required],
        phone: new FormControl(this.user.phone, [Validators.required]),
        school: [this.user.school.name],
        ID_PHOTO: [null, [Validators.required]],
        LETTRE_D_ADMISSION: [null, [Validators.required]],
        discoverUs: [this.user.discover_from && this.user.discover_from.includes('COMMON.DISCOVER_US') ? this.user.discover_from : (this.user.discover_from ? 'COMMON.DISCOVER_US.OTHER' : null)],
        discoverUsMore: [this.user.discover_from ? (this.user.discover_from.includes('COMMON.DISCOVER_US') ? null : this.user.discover_from) : null],
        school_name: [uInfos ? uInfos.interestName : null],
      });
      const currentNationality = this.countryService.getCountry(this.user.nationality);
      if (currentNationality && currentNationality.name) {
        currentNationality.name = this.translate.instant(currentNationality.name);
        countryCode = currentNationality;
        this.userForm.controls.nationality.setValue(countryCode);
      }
      //this.metaService.sendPageView('ViewPropertyInformation', 'property/list', this.user.id, this.room.id, 'property').subscribe();
    }

  }

  ngAfterViewInit(){
    if (window.location.hash === '#reload' && this.user) {
      this.userService.getCityById(this.room.property_address.city_group).subscribe((data: any) => {
        let hubspotDatas = {
          city: data.name,
          campagne: '',
          source: '',
          medium: ''
        };

        hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
        this.userService.setHubspotDeal(3321704, 11339147, hubspotDatas).subscribe();
        if (this.user.school_id === 53) {
          this.hubspotService.updateHubspot({
            studies_city: data.name
          }).subscribe();
        }
      });
    }
  }

  // Documents
  public onFileDelete($event): void {
    const doc = $event.documentType;
    this.userForm.controls[doc].setValue(null);
  }

  public onFileUpload($event): void {
    const doc = $event.documentType;
    this.userForm.controls[doc].setValue(true);
  }

  //-------
  public getAddress(address: any, type: string): void {
    if (type == 'address') {
      this.userFormattedAddress = address;
    } else {
      this.userFormattedAddress['additional'] = ' ' + address;
    }
  }

  public getBirthdate(birthdate): void {
    if (birthdate.yearControl && birthdate.monthControl && birthdate.dayControl) {
      const dateCheck = new Date(birthdate.yearControl, birthdate.monthControl - 1, birthdate.dayControl);
      if (dateCheck.getFullYear() != birthdate.yearControl || (dateCheck.getMonth() + 1) != birthdate.monthControl || dateCheck.getDate() != birthdate.dayControl) {
        this.isBirthdayCorrect = false;
      } else {
        this.isBirthdayCorrect = true;
        this.fUser.birthdate.setValue(dateCheck.getFullYear() + '-' + (dateCheck.getMonth() + 1) + '-' + dateCheck.getDate());
      }
    }
  }

  public setCity(city: any): void {
    this.hasBeenClicked = false;
    if (city.formatted_address) {
      let replace = city.formatted_address.replace('-', ',')
      let split = replace.split(', ');
      if(split.length > 1){
        this.nationality = split[split.length - 1];
        split.splice(split.length - 1, 1);
      }
      this.fUser.birthplace.setValue( split.join(', ').replace(/[0-9]/g, '').replace(/\s/g, ""));
      this.hasBeenClicked = true;
      this.errors.birthplace = null;
      this.userForm.controls['birthplace'].setErrors(null);
      this.fullHomeAddress = city.fullHomeAddress ? city.fullHomeAddress : null;
    }
    else if (city && this.isManualInput === true){
      this.fUser.birthplace.setValue(city);
      this.hasBeenClicked = true;
      this.errors.birthplace = null;
      this.userForm.controls['birthplace'].setErrors(null);
      this.fullHomeAddress = city ? city : null;
    }
    else {
      this.errors.birthplace = this.translate.instant('COMMON.NOT_CLICK_IN_LIST');
      this.userForm.controls['birthplace'].setErrors({'incorrect': true});
      this.hasBeenClicked = false;
    }

  }

  public onCountrySelected(event): void {
    if(event){
      this.userForm.patchValue({nationality: event});
      this.user.nationality = event.alpha2Code;
    }
  }

  public submit(): void {
    this.isFormSubmitted = true;
    this.isFetching = true;
    let discoverFrom;

    if (this.userForm.value.discoverUs && this.userForm.value.discoverUs != 'COMMON.DISCOVER_US.OTHER') {
      discoverFrom = this.userForm.value.discoverUs;
    } else {
      if (this.userForm.value.discoverUsMore) {
        discoverFrom = this.userForm.value.discoverUsMore;
      } else {
        discoverFrom = this.userForm.value.discoverUs;
      }
    }
    this.checkDocuments().pipe(first()).subscribe(checks => {
      if (checks[0] && checks[1]) {
        let homeCityValue = null;
        if (this.userFormattedAddress.city_id) {
          homeCityValue = this.userFormattedAddress.city_id;
        } else {
          if (this.userFormattedAddress.city) {
            homeCityValue = this.userFormattedAddress.city.id;
          }
        }

        this.birthdayInputs.dayControl.markAsTouched();
        this.birthdayInputs.monthControl.markAsTouched();
        this.birthdayInputs.yearControl.markAsTouched();
        this.cityInput.cityControl.markAsTouched();
        this.addressInput.addressControl.markAsTouched();
        const referer = this._localSettings.getReferer() ? this._localSettings.getReferer() : null;
        if (this.userForm.value.phone && this.userForm.value.phone.internationalNumber) {
          this.userForm.value.phone = this.userForm.value.phone.internationalNumber;
        }

        if (this.userForm.valid && this.birthdayInputs.dateForm.valid && this.isBirthdayCorrect && this.userFormattedAddress['country'] && this.hasBeenClicked) {
          this.userService.update({
            firstname: this.userForm.value.firstname,
            lastname: this.userForm.value.lastname,
            birthdate: this.userForm.value.birthdate,
            birthplace: this.userForm.value.birthplace,
            phone: this.userForm.value.phone,
            nationality: this.user.nationality,
            homeAddress: (this.userFormattedAddress['number'] ? this.userFormattedAddress['number'] + ' ' : '') + this.userFormattedAddress['route'],
            homeAdditionalAddress: this.userFormattedAddress['additional'] ? this.userFormattedAddress['additional'] : this.additionalAddressFormControl.value,
            homeCity_id: homeCityValue,
            fullHomeAddress: this.fullHomeAddress ? this.fullHomeAddress.fullHomeAddress : this.fullHomeAddress ? this.fullHomeAddress : null,
            postalCode: this.userFormattedAddress['postal_code'],
            country: this.userFormattedAddress['country'],
            referer: referer,
            discover_from: discoverFrom,
            interestName: this.userForm.controls.school_name.value,
          }).pipe(first()).subscribe();
          this.newPage.emit('paiement');
          const metropole = this.room.property_address.metropole ? this.room.property_address.metropole : this.room.property_address.city_group;
          this.location.replaceState(this.currentLanguage + "/accommodation/payment?originCity=" + metropole);
        }
        this.isFetching = false;
      } else {
        this.documentInvalid();
      }

      }, (error) => {
      this.documentInvalid();
    })
  }

  private getCountries() {
    this.predefinedCountries = [];
    this.predefinedCountries = this.countryService.getCountries();
    this.translate.get('COUNTRIES').subscribe((value) => {
      this.predefinedCountries.forEach(element => {
        const code = element.alpha2Code;
        element.name = this.translate.instant('COUNTRIES.' + code);
      });
    });
  }

  private getDocument(doc): void {
    if (this.authenticationService.currentUserValue) {
      this.userDocumentService.getDocuments(doc).pipe(take(1)).subscribe((data) => {
        if (data.documents.length > 0) {
          this.userForm.controls[doc].setValue(true);
        }
      });
    }
  }

  private checkDocuments(): Observable<unknown> {
    const check1 = from([this.userDocumentService.checkDocument('LETTRE_D_ADMISSION')]);
    const check2 = from([this.userDocumentService.checkDocument('ID_PHOTO')]);
    return forkJoin([
      check1, check2
    ]).pipe(
      map(([check1, check2]) => [check1, check2])
    );
  }

  private documentInvalid(): void {
    this.isFetching = false;
    if (!this.fUser.ID_PHOTO.errors) {
      this.fUser.ID_PHOTO.setErrors({'required': true});
    }
    if (!this.fUser.LETTRE_D_ADMISSION.errors) {
      this.fUser.LETTRE_D_ADMISSION.setErrors({'required': true});
    }
    this.alertService.openSnackBar('COMMON.DOCUMENTS_UPLOAD.ERROR', 'snack-error');
  }




  public checkLatin(field,e){
    const  regex = new RegExp("^[A-zÀ-ÿ0-9- ']+$");
    if (regex.test(e.target.value)) {
      this.errors[field] = null;
      this.userForm.controls[field].setErrors(null);
    }
    else{
      this.errors[field] = this.translate.instant('COMMON.ONLY_LATIN_ERROR');
      this.userForm.controls[field].setErrors({'incorrect': true});
    }
  }

  changeManualInput(){
    this.isManualInput = !this.isManualInput;
    this.userForm.controls['birthplace'].setErrors(null);
    this.errors.birthplace = null;
  }


}
